
import oAxios from 'axios';
import { LANGUAGES } from 'constants/Languages';
import promise from 'promise';
import { actionLogout } from 'redux/actions/UserActions';
import { getLanguageLocalStorage, getTokenLocalStorange } from 'redux/services/StorageServices';
import store from 'redux/Store';
import { PERMISSIONS, DENIED_BY_ADMIN } from 'constants/StatusCode';
import { actionMessage } from 'redux/actions/SharedActions';

var oAxiosInstance = oAxios.create();

oAxiosInstance.interceptors.request.use(async function (oConfig) {
    var sToken = await getTokenLocalStorange();
    if (sToken)
        if (oConfig.method !== 'OPTIONS')
            oConfig.headers.Authorization = sToken;
    var sLanguage = await getLanguageLocalStorage();
    oConfig.headers.Language = sLanguage ? sLanguage : LANGUAGES.PORTUGUESE;
    //? Se toma la diferencia en minutos de la zona horaria
    let nTimeZoneOffset = new Date().getTimezoneOffset();
    if (nTimeZoneOffset != null)
        oConfig.headers.TimeZone = nTimeZoneOffset;
    return oConfig;
}, function (oError) {
    return promise.reject(oError);
});

oAxiosInstance.interceptors.response.use(oResponse => {
    return promise.resolve(oResponse);
}, oError => {

    if (oError.response && oError.response.status === PERMISSIONS) {
        store.dispatch(actionLogout());
        return promise.reject(oError.response);
    }

    if (oError.response && oError.response.status === DENIED_BY_ADMIN) {
        store.dispatch(actionMessage('DENIED_BY_ADMIN'));
        return promise.reject(oError.response);
    }

    return promise.reject(oError.response);
});

export default oAxiosInstance;